import { render, staticRenderFns } from "./youtube-video-widget.vue?vue&type=template&id=899f35c8&scoped=true"
import script from "./youtube-video-widget.vue?vue&type=script&lang=js"
export * from "./youtube-video-widget.vue?vue&type=script&lang=js"
import style0 from "./youtube-video-widget.vue?vue&type=style&index=0&id=899f35c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "899f35c8",
  null
  
)

export default component.exports